const EXPIRY_SKEW_MS = 60_000

export interface DesktopJwtClaims {
  userId: string | null
  expiresAt: number | null
  anonymous: boolean
}

export function readDesktopJwtClaims(token: string): DesktopJwtClaims | null {
  const payload = decodeJwtPayload(token)
  if (!payload) {
    return null
  }
  const expiresAt = typeof payload.exp === 'number' ? payload.exp * 1000 : null
  return {
    userId: firstString(payload.sub, payload.user_id, payload.userId, payload.uid),
    expiresAt,
    anonymous: payload.atp === 'a',
  }
}

/** True when the bearer is already expired or within 60s of expiring. */
export function isDesktopBearerStale(token: string, now: number = Date.now()): boolean {
  const expiresAt = readDesktopJwtClaims(token)?.expiresAt
  if (expiresAt === null || expiresAt === undefined) {
    return false
  }
  return expiresAt <= now + EXPIRY_SKEW_MS
}

function firstString(...values: unknown[]): string | null {
  for (const value of values) {
    if (typeof value === 'string' && value.length > 0) {
      return value
    }
  }
  return null
}

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const part = token.split('.')[1]
  if (!part) {
    return null
  }
  try {
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')
    const payload = JSON.parse(atob(padded)) as unknown
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
      return null
    }
    return payload as Record<string, unknown>
  } catch {
    return null
  }
}
